import createCRUDObservable from 'redux-observable-crud'
import { Observable } from 'rxjs'
import { push } from 'react-router-redux'
import { clone } from 'ramda'
import { combineEpics } from 'redux-observable'
import ContractsActions, { ContractsRedux, ContractsTypes } from '../Redux/ContractsRedux'
import CompaniesAction, { CompaniesRedux, CompaniesTypes } from '../Redux/CompaniesRedux'
import { notificationSuccess, notificationFail } from '../Redux/NotificationActions'


const contractsCrudObservable = createCRUDObservable({
  mainRedux: ContractsRedux,
  reduxPath: 'contracts',
})

const removeContractEpic = action$ => (
  action$.ofType(ContractsTypes.removeSuccess)
    .flatMap(data => [
      CompaniesAction.contractRemoveSuccess(data),
    ])
)

const updateContractEpic = (action$, store, { Api }) =>
  action$.ofType(ContractsTypes.contractsUpdateRequest).mergeMap(({ id, data }) =>
    Observable.fromPromise(
      Api.contracts
        .updateContract(id, data)
        .then(response => response)
        .catch(error => error),
    ).flatMap((response) => {
      const { status } = response
      const company = clone(store.getState().companies.getOne.result)
      if (!(status >= 200 && status < 300)) {
        // const error = response.error.errors
        // const index = Object.keys(error)[0]
        return [
          ContractsActions.contractsUpdateFailure(response.error),
          notificationFail('Error', response.error),
        ]
      }
      const result = response.data.data
      return [
        notificationSuccess('Exitosa', 'Informacion Actualizada'),
        ContractsActions.contractsUpdateSuccess(),
        CompaniesAction.contractUpdateSuccess(result),
        push(`/companies/${company.id}`),
      ]
    },
    ),
  )

const retoreContractEpic = (action$, store, { Api }) =>
  action$.ofType(ContractsTypes.contractRestoreRequest).mergeMap(({ id }) =>
    Observable.fromPromise(
      Api.contracts
        .restoreContract(id)
        .then(response => response)
        .catch(error => error),
    ).flatMap((response) => {
      const { status } = response
      const result = response.data.data
      const company = clone(store.getState().companies.getOne.result)
      if (!(status >= 200 && status < 300)) {
        // const error = response.error.errors
        // const index = Object.keys(error)[0]
        return [
          ContractsActions.contractRestoreFailure(response.error),
          notificationFail('Error', response.error),
        ]
      }
      return [
        notificationSuccess('Exitosa', ' Restauracion Exitosa.'),
        ContractsActions.contractRestoreSuccess(),
        CompaniesAction.contractRestoreSuccess(id),
      ]
    },
    ),
  )

export const contractsObservers = Object.assign({}, contractsCrudObservable.observers, {})

export const contractsEpic = combineEpics(
  contractsCrudObservable.epic,
  updateContractEpic,
  retoreContractEpic,
  removeContractEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/ContractsObservable.js